import { Articles, Article } from '@/models/Article';

import { make } from 'vuex-pathify';

const state = {
	active: new Articles(),
	archived: new Articles(),
	showAddArticlesForm: false,
};

const getters = {

	/**
	 * Returns all articles, active and archived
	 *
	 * @param {Object} state This store
	 * @returns {Articles} Combined active and archived articles collection
	 */
	all: (state) => {
		const models = state.active.models.concat(state.archived.models);
		return new Articles(models);
	},

};

const mutations = {
	...make.mutations(state),
};

const actions = {

	/**
	 * Loads all articles (active and archived),
	 * then filters in two groups for active and archived and adds to the store
	 *
	 * @param {Object} param0 Destructed context object
	 * @param {number} reportId Report ID, to which articles belong to
	 * @returns {Promise} Result of fetching all articles from backend
	 */
	loadAll({ state, commit }, reportId) {
		return new Promise((resolve, reject) => {

			// Clear the state
			state.active.clear();
			state.archived.clear();

			const articles = new Articles();
			articles.set('id', reportId)
			articles.fetch().then((resp) => {

				articles.each(article => {
					article.isDeleted ? state.archived.add(article) : state.active.add(article);
				});

				/**
				 * Set to old store as well for now
				 * @todo To be deleted
				 */
				commit('SET_ARTICLES', state.active.models, { root: true });
				commit('SET_DELETED_ARTICLES', state.archived.models, { root: true });

				resolve(articles);
			}).catch((e) => {
				dump('Error fetching all articles', e);
				reject(e);
			});
		});
	},

	/**
	 * Archives article, moves article from active collection to archived
	 * @todo Add check if successfull, maybe return promise with try/catch
	 *
	 * @param {Object} param0 Destructed context object
	 * @param {Article} article Selected article
	 */
	archive({ state }, article) {
		state.active.remove(article);
		state.archived.add(article);
	},

	/**
	 * Restores article, moves article from archived collection to active
	 * @todo Add check if successfull, maybe return promise with try/catch
	 *
	 * @param {Object} param0 Destructed context object
	 * @param {Article} article Selected article
	 */
	restore({ state }, article) {
		state.archived.remove(article);
		state.active.add(article);
	},

	/**
	 * @todo
	 */
	// move({ state }, articles, report, categoryId) {
	// 	return new Promise((resolve, reject) => {
	// 		console.log(articles);
	// 		console.log(report);
	// 		console.log(categoryId);
	// 		resolve();
	// 	});
	// },

	/**
	 * @todo
	 */
	// copy({ state }, articles, report, categoryId) {
	// 	return new Promise((resolve, reject) => {

	// 	});
	// }

};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
